export default __webpack_public_path__ + "static/media/logo.1b1d4b5a.jpg";